var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Products & Services ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("p", [
                    _vm._v(
                      " Enter the details of up to 6 products or services that you offer. If you don’t have any or would like to add this information later, click Next Step. "
                    )
                  ]),
                  _vm._l(_vm.starterSite.contentServices, function(
                    service,
                    index
                  ) {
                    return [
                      _c("v-textarea", {
                        key: "ps-".concat(index),
                        staticClass: "mb-4",
                        attrs: {
                          value: service,
                          placeholder:
                            "Provide content for Your Website's Services or Products Section",
                          rows: "3",
                          outlined: "",
                          dense: "",
                          "hide-details": ""
                        },
                        on: {
                          change: function change($event) {
                            return _vm.setService($event, index)
                          }
                        }
                      })
                    ]
                  })
                ],
                2
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-btn",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.starterSite.contentServices.length <
                            _vm.maxServices,
                          expression:
                            "starterSite.contentServices.length < maxServices"
                        }
                      ],
                      attrs: {
                        secondary: ""
                      },
                      on: {
                        click: _vm.addService
                      }
                    },
                    [_vm._v("Add Item")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }